export const configuratorProperty = {
    id: 'id',
    colour: 'colour',
    trim: 'trim',
    accessories: 'accessories',
};

export const groupType = {
    wheels: 'wheels',
};
